import React, { useEffect } from 'react';
import * as gmailServices from '../../../services/gmail';
import { Spin } from 'antd';
import { notification } from 'components/ui';

const AuthorizeGmailAccountSuccess = ({ location, history }) => {
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const domain = queryParams.get('state');
    if (!code) {
      history.push('/mail/gmail');
      return;
    }

    gmailServices
      .authorizeGmailAccountSuccess({ code, domain })
      .then(res => {
        history.replace('/mail/gmail');
        notification.success({
          message: 'Gmail Authorized',
          description: res?.email,
        });
      })
      .catch(e => {
        history.replace('/mail/gmail');
        notification.error({
          message: 'Gmail Authorization Failed',
          description: e?.response?.data?.error?.message || null,
        });
      });
  }, []);

  return <Spin spinning />;
};

export default AuthorizeGmailAccountSuccess;
